// extracted by mini-css-extract-plugin
export default {"source":"sourceLabel_source__nqXva"};